import serviceRequest from "utils/request";

const baseUrl = "/api/publicationReview";

export const updatePublicationRequest = (param) => {
	return serviceRequest({
		url: `${baseUrl}/update-publication-review`,
		method: "post",
		data: param,
	});
};

export const updatePublicationRequestRes = (param) => {
	return serviceRequest({
		url: `${baseUrl}/update-publication-review-res`,
		method: "post",
		data: param,
	});
};

export const getPublicationUserProjects = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-user-projects`,
		method: "get",
		params,
	});
};

export const getPublicationRequests = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-publication-reviews`,
		method: "get",
		params,
	});
};

export const getPublicationRequestsRes = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-publication-reviews-res`,
		method: "get",
		params,
	});
};

export const getPublicationRequestDetail = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-publication-review-detail`,
		method: "get",
		params,
	});
};

export const getPublicationStatement = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-form-statement`,
		method: "get",
		params,
	});
};
